/** Existing Admin Live Chat branding payload → homepage floating button. */

export const LIVE_CHAT_CHANNEL_ORDER = ['liveChat', 'tawk', 'messenger', 'telegram', 'whatsapp'];

export const LIVE_CHAT_CHANNEL_LABELS = {
  liveChat: 'Customer Support',
  tawk: 'Tawk.to Support',
  messenger: 'Messenger Support',
  telegram: 'Telegram Support',
  whatsapp: 'WhatsApp Support',
  other: 'Support',
};

export const LIVE_CHAT_TYPE_ICON = {
  messenger: '/social/messenger.svg',
  telegram: '/social/telegram.svg',
  whatsapp: '/social/whatsapp.svg',
};

export function isHomepagePath(pathname) {
  const raw = String(pathname || '');
  const path = raw.length > 1 && raw.endsWith('/') ? raw.slice(0, -1) : raw;
  return path === '/' || path === '';
}

export function isSafeLiveChatUrl(url) {
  const value = String(url || '').trim();
  if (!value) return false;
  try {
    const parsed = new URL(value);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch {
    return false;
  }
}

export function listActiveLiveChatServices(liveChat) {
  if (Array.isArray(liveChat?.services)) {
    return liveChat.services.filter((row) => row && isSafeLiveChatUrl(row.url));
  }
  const channels = liveChat?.channels || {};
  return LIVE_CHAT_CHANNEL_ORDER.flatMap((key) => {
    const channel = channels[key];
    if (!channel?.enabled || !isSafeLiveChatUrl(channel.link)) return [];
    return [
      {
        id: key,
        type: key,
        label: LIVE_CHAT_CHANNEL_LABELS[key] || LIVE_CHAT_CHANNEL_LABELS.other,
        url: channel.link,
      },
    ];
  });
}

export function shouldShowHomeLiveChatFab({ pathname, liveChat } = {}) {
  if (!isHomepagePath(pathname)) return false;
  return listActiveLiveChatServices(liveChat).length > 0;
}

export function resolveLiveChatFabLogo(branding, fallbackSrc) {
  const url = String(branding?.liveChatImage?.url || branding?.liveChatImage || '').trim();
  return url || fallbackSrc || '';
}

export function resolveLiveChatOptionIcon(service, branding, fallbackSrc) {
  const type = String(service?.type || '').trim();
  if (LIVE_CHAT_TYPE_ICON[type]) return LIVE_CHAT_TYPE_ICON[type];
  return resolveLiveChatFabLogo(branding, fallbackSrc);
}

export function openLiveChatUrl(url, openFn) {
  if (!isSafeLiveChatUrl(url)) return false;
  const open = openFn || (typeof window !== 'undefined' ? window.open.bind(window) : null);
  if (!open) return false;
  open(url, '_blank', 'noopener,noreferrer');
  return true;
}
